import { OrdreStatut } from './enums';

/**
 * Frontière « à traiter » / « réalisé » des opérations.
 *
 * Un seul axe d'états, celui de l'exploitation : la bascule se fait à la
 * LIVRAISON. Un ordre livré a quitté la file de travail et rejoint le réalisé,
 * même si son volet administratif n'est pas soldé — la facturation n'est pas
 * gérée ici (elle vit dans l'ERP), elle ne pilote donc aucun statut.
 */

/** Statuts d'un envoi déjà roulé : il alimente le réalisé. */
const REALISES: ReadonlySet<OrdreStatut> = new Set([OrdreStatut.LIVRE, OrdreStatut.CLOTURE]);

/** Statuts sortis de la file de travail sans avoir été exécutés. */
const ABANDONNES: ReadonlySet<OrdreStatut> = new Set([OrdreStatut.ANNULE]);

/** L'envoi est livré (ou clôturé) : il compte dans le réalisé. */
export function estRealise(statut: OrdreStatut): boolean {
  return REALISES.has(statut);
}

/**
 * L'envoi demande encore une action ops : ni livré, ni annulé. C'est le
 * prédicat qui peuple la console « Demandes ».
 */
export function estATraiter(statut: OrdreStatut): boolean {
  return !REALISES.has(statut) && !ABANDONNES.has(statut);
}
